module.exports = __webpack_public_path__ + "img/brd.92fea245.svg";